<template>
  <div>
    <ConfirmActionModal
      :header="$t('invitation.confirm_acceptance')"
      :is-loading="isLoading"
      :show="isShowConfirm"
      @action="$emit('confirm')"
      :button-text="$t('buttons.yes')"
      button-color="green-5"
      @close="$emit('update:isShowConfirm', false)"
    />
    <ConfirmActionModal
      :header="$t('invitation.confirm_rejection')"
      :is-loading="isLoading"
      :show="isShowUnConfirm"
      button-color="red-5"
      :button-text="$t('buttons.yes')"
      @action="$emit('unConfirm')"
      @close="$emit('update:isShowUnConfirm', false)"
    />
  </div>
</template>

<script>
import ConfirmActionModal from "~/components/Modal/ConfirmActionModal.vue";

export default {
  name: "InvitationModals",
  props: {
    isLoading: Boolean,
    isShowConfirm: Boolean,
    isShowUnConfirm: Boolean,
  },
  components: {
    ConfirmActionModal
  },
  emits: ['update:isShowConfirm', 'update:isShowUnConfirm', 'confirm', 'unConfirm']
}
</script>